import { render } from "./EventsSection.vue?vue&type=template&id=8e7af2aa&scoped=true"
import script from "./EventsSection.vue?vue&type=script&lang=js"
export * from "./EventsSection.vue?vue&type=script&lang=js"

import "./EventsSection.vue?vue&type=style&index=0&id=8e7af2aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7af2aa"]])

export default __exports__